module.exports = __webpack_public_path__ + "img/cancel_order.087c3aba.svg";